import 'reactflow/dist/style.css';
import FlowNode from "./components/flowmap/FlowNode";
import {useNodesData, connections} from "./NodeData";
import {useEffect, useRef, useState} from "react";
import FlowPath from "./components/flowmap/FlowPath";
import StarField from "./components/StarField";
import { getResponsiveStyles } from './App_style.js';
import { applyCSSVariables } from './StyleBase_style.js';
import { zoom } from './zoomUtils.js';

function App() {

    const containerRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [styles, setStyles] = useState(getResponsiveStyles());

    // Get nodes with refs from custom hook
    const nodesData = useNodesData();

    useEffect(() => {
        // Apply CSS variables on mount
        applyCSSVariables();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
            setStyles(getResponsiveStyles());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const flowNodes = nodesData.map((node) => (
        <FlowNode
            key={node.id}
            ref={node.ref}
            className={node.id}
            modalContent={node.modalContent}
            style={{
                // Grid positioning
                gridArea: isMobile ? node.gridArea.mobile : node.gridArea.desktop,
                
                // Dynamic sizing (needs React state) - but NOT for intro node
                ...(node.id !== 'intro' && {
                    minWidth: isMobile ? zoom('120px') : zoom('120px'),
                    maxWidth: isMobile ? zoom('200px') : zoom('220px'),
                    width: isMobile ? 'fit-content' : 'auto',
                    padding: isMobile ? zoom('8px') + ' ' + zoom('12px') : zoom('12px') + ' ' + zoom('16px'),
                    fontSize: isMobile ? zoom('14px') : zoom('16px'),
                })
            }}
        >
            {node.content}
        </FlowNode>
    ));

    const flowPaths = connections.map((connection) => {
        const fromNode = nodesData.find(n => n.id === connection.from);
        const toNode = nodesData.find(n => n.id === connection.to);

        return (
            <FlowPath
                key={`path-${connection.from}-${connection.to}`}
                fromRef={fromNode.ref}
                toRef={toNode.ref}
                containerRef={containerRef}
            />
        );
    });
    return (
        <div style={styles.app}>
            <StarField particleCount={800} speed={0.8} starSize={0.9} /> {/*slower background stars*/}
            <StarField particleCount={200} speed={1.2} starSize={1} twinkle={false} /> {/*faster foreground stars - no twinkle*/}
            
            {/* Vignette overlay */}
            <div style={{
                content: "''",
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                boxShadow: `
                    inset 0 0 ${zoom('40vmin')} rgba(0,0,0,0.2),
                    inset 0 0 ${zoom('60vmin')} rgba(0,0,0,0.3),
                    inset 0 0 ${zoom('80vmin')} rgba(0,0,0,0.4)
                `,
                pointerEvents: 'none',
                zIndex: 1000,
                transition: 'box-shadow 0.2s ease-out'
            }} />
            
            <div style={styles.flowContainer} ref={containerRef}>
                {flowNodes}
                {flowPaths}
            </div>
            
        </div>
    );
}

export default App;